import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogShow } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { Panel } from "primereact/panel";

//PAGE
import P303Search from "./P303Search";
import P303ListA from "./P303ListA";
import P303ListB from "./P303ListB";
import P303ListC from "./P303ListC";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P303GetDataListA, P303GetDataListB, P303GetDataListC } from "../../../service/300/P303Service";
import { formatDateAPI } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P303() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const [loading, setLoading] = useState(false);
    const [headerListB, setHeaderListB] = useState("");
    const [headerListC, setHeaderListC] = useState("");

    //SEARCH DATE
    const [searchDate, setSearchDate] = useState({
        dateBegin: new Date(new Date().setDate(1)),
        dateEnd: new Date(),
    });

    // SEARCH List A
    const [dataTableA, setDataTableA] = useState([]);
    const [searchDataA, setSearchDataA] = useState({
        branchCode: dataUserSession()?dataUserSession().userBranchCode:'',
        dateBegin: "",
        dateEnd: "",
        userId: dataUserSession()?dataUserSession().userId:''
    });

    // SEARCH List B
    const [dataTableB, setDataTableB] = useState([]);
    const [searchDataB, setSearchDataB] = useState({
        supervisorUserId: "",
        dateBegin: "",
        dateEnd: "",
        userId: dataUserSession()?dataUserSession().userId:'',
    });

    // SEARCH List C
    const [dataTableC, setDataTableC] = useState([]);
    const [searchDataC, setSearchDataC] = useState({
        supervisorUserId: "",
        dateBegin: "",
        dateEnd: "",
        contractNo : "",
        userId: dataUserSession()?dataUserSession().userId:'',
    });

    useEffect(() => {

        dataUserSession()

        if (!dataUserSession()) {
            history.push("/login");
        }else{
            if (history.location.state && history.location.state.branchCode) {
                setSearchDataA({
                    ...searchDataA,
                    ...history.location.state.branchCode,
                });
            }
        }
    }, []);

    useEffect(() => {
        onP303GetDataListA();
    }, [searchDataA]);

    useEffect(() => {
        onP303GetDataListB();
    }, [searchDataB]);

    useEffect(() => {
        // onP303GetDataListC();
    }, [searchDataC]);

    const onP303GetDataListA = () => {
        setLoading(true);
        console.log("🚀 ~ file: P303.js ~ line 95 ~ onP303GetDataListA ~ searchDataA", searchDataA)
        P303GetDataListA(searchDataA).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableA(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP303GetDataListB = (event) => {
        let newData = {}
        if(event && event.data){
            newData = {
                ...searchDataB,
                supervisorUserId :event.data.supervisorUserId
            }

            setHeaderListB(event.data.supervisorName)

            setSearchDataC({
                ...searchDataC,
                supervisorUserId :event.data.supervisorUserId
            })
        }else{
            newData = {
                ...searchDataB,
                supervisorUserId :searchDataB.supervisorUserId
            }
        }

        setLoading(true);
        P303GetDataListB(newData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableB(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP303GetDataListC = (event) => {
        let newData = {}
        if(event && event.data){
            newData = {
                ...searchDataC,
                contractNo :event.data.contractNo
            }
            setHeaderListC(event.data.contractNo)
        }else{
            newData = {
                ...searchDataC,
                contractNo :searchDataC.contractNo
            }
        }
        setLoading(true);
        P303GetDataListC(newData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableC(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const searchForm = (searchDate) => {

        setSearchDataA({
            ...searchDataA,
            dateBegin: searchDate.dateBegin !== "" ? formatDateAPI(searchDate.dateBegin, false) : "",
            dateEnd: searchDate.dateEnd !== "" ? formatDateAPI(searchDate.dateEnd, false) : "",
        })

        setSearchDataB({
            ...searchDataB,
            dateBegin: searchDate.dateBegin !== "" ? formatDateAPI(searchDate.dateBegin, false) : "",
            dateEnd: searchDate.dateEnd !== "" ? formatDateAPI(searchDate.dateEnd, false) : "",
        })

        setSearchDataC({
            ...searchDataC,
            dateBegin: searchDate.dateBegin !== "" ? formatDateAPI(searchDate.dateBegin, false) : "",
            dateEnd: searchDate.dateEnd !== "" ? formatDateAPI(searchDate.dateEnd, false) : "",
        })

    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">

                        <P303Search
                            searchDate={searchDate}
                            setSearchDate={setSearchDate}
                            searchForm={searchForm}
                            history={history}
                        />

                        <Panel header="รายละเอียดผู้คุมงาน" toggleable>
                            <P303ListA dataTable={dataTableA} onRowClick={onP303GetDataListB}  />
                        </Panel>
                        {
                            headerListB && headerListB !== '' ?(
                                <>
                                    <br/>
                                    <Panel header={`รายละเอียดสัญญาของ : ${headerListB}`} toggleable>
                                        <P303ListB dataTable={dataTableB} onRowClick={onP303GetDataListC} />
                                    </Panel>
                                </>
                            ):('')

                        }
                        {
                            headerListC && headerListC !== '' ?(
                                <>
                                    <br/>
                                    <Panel header={`รายละเอียดการตรวจงาน ตามใบแจ้งฯ สัญญาที่ ${headerListC}`} toggleable>
                                        <P303ListC dataTable={dataTableC} />
                                    </Panel>
                                </>
                            ):('')

                        }


                    </div>
                </div>
            </div>
        </>
    );
}
